"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SipMediaEncryptionEnum = void 0;
exports.SipMediaEncryptionEnum = {
    Disabled: "disabled",
    Allowed: "allowed",
    Required: "required",
};
